<template>
    <div class="inline">
        <a-button type="link" @click="show">查看详情</a-button>
        <a-modal :centered="true" :footer="null" :width="1000" :visible="visible" :destroyOnClose="true"
            :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="班级任务详情" @cancel="visible = false">
            <a-table :dataSource="list" :rowKey="item => item.id" :pagination="false" :loading="loading">
                <a-table-column data-index="student_name" key="student_name">
                    <template #title>
                        {{ `学生姓名(${list.length}人)` }}
                    </template>
                </a-table-column>
                <a-table-column key="status" title="是否出勤">
                    <template slot-scope="item">
                        <a-tag v-if="item.status == 0" color="#87d068">出勤</a-tag>
                        <a-tag v-if="item.status == 1" color="#2db7f5">调课</a-tag>
                        <a-tag v-if="item.status == 2" color="#f50">请假</a-tag>
                        <a-tag v-if="item.status == 3" color="#108ee9">其他</a-tag>
                    </template>
                </a-table-column>
                <a-table-column data-index="remarks" key="remarks" title="备注" />
            </a-table>
            <div style="text-align: right;margin-top: 1rem;">
                <a-button type="primary" @click="visible = false">关闭</a-button>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    props: {
        kq_time: {
            type: String,
            require: true
        },
        squad_id: {
            type: String,
            require: true
        }
    },
    data() {
        return {
            loading: false,
            visible: false,
            list: []
        }
    },
    methods: {
        show() {
            this.loading = true;
            this.$axios.post('/api/Attendance/getAttenAllStudentList', {
                data: {
                    kq_time: this.kq_time,
                    squad_id: this.squad_id
                }
            }).then(res => {
                this.list = res.data;
                this.loading = false;
                this.visible = true;
            })
        }
    }
}
</script>
<style lang="less" scoped>
.inline {
    display: inline;
    margin-right: 1rem;
}
</style>